import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from '../commons/abstract.service';
import { Stage } from "../models/stage.modal";
import { Observable } from "rxjs";
import { LossReason } from "../models/loss-reason.model";

@Injectable({ providedIn: 'root' })
export class StageService extends AbstractService<Stage> {
  constructor(private http: HttpClient) {
    super(http);
  }

  getURLBase(): string {
    return '/stage';
  }

  preCreate(obj: Stage): void {
    delete obj._id;
  }

  preUpdate(obj: Stage): void {
  }

  getStagesByFunnel(idFunnel: string): Observable<Array<Stage>> {
    return super.get(`/${idFunnel}`);
  }

  reorderStages(idFunnel: string, orderedStageIds: Array<string>): Observable<void> {
    return super.post(`/reorder/${idFunnel}`, { orderedStageIds });
  }

  updateStageStatus(idStage: string, action: 'won' | 'lost' | 'reset', lossReason?: LossReason): Observable<void> {

    const payload = { action, lossReason };
    return super.post(`/stage-status/${idStage}`, payload);
  }
}
